module.exports = __webpack_public_path__ + "img/2.394e0c53.png";